import { BaseReducer } from '@hobs/utils/baseReducer';
import {
  GET,
  CLEAR,
  CONFIRM_DELIVERY_FOR_SUBMIT
} from '@hobs/constants/orders';

const OrderShape = {
  status: {},
  subcontractorInformation: {},
  orderInformation: {},
  serviceRequests: [],
  attachments: []
};

class Orders extends BaseReducer {
  static defaultState = {
    order: OrderShape,
    forSubmit: {}
  };
  constructor() {
    super(Orders.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.addOrderResults,
      [CONFIRM_DELIVERY_FOR_SUBMIT.SUCCESS]: this.addConfirmDeliveryForSubmit,
      [CLEAR.SUCCESS]: this.clearOrderResults
    };
  }

  addOrderResults = (state, action) => {
    return Object.assign({}, state, { order: action.response });
  };

  clearOrderResults = state => {
    return Object.assign({}, state, { order: OrderShape });
  };

  addConfirmDeliveryForSubmit = (state, action) => {
    return Object.assign({}, state, { forSubmit: action.response });
  };
}

export default new Orders().reducer;
